export const fakeStudent = {
  columns: [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
    },
    {
      title: "Course",
      dataIndex: "course",
      key: "course",
    },
    {
      title: "Entry Grade",
      dataIndex: "egrade",
      key: "egrade",
    },
    {
      title: "Total Credit",
      dataIndex: "credit",
      key: "credit",
    },
    {
      title: "Natioinality",
      dataIndex: "nationality",
      key: "nationality",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
  ],
  data: [
    {
      name: "Daniel Regna",
      gender: "Female",
      course:"Agronomy",
      egrade:"130.0",
      credit:"16",
      nationality:"Nigerian",
      status:"Graduate",
    },
    {
      name: "Daniel Regna",
      gender: "Female",
      course:"Agronomy",
      egrade:"130.0",
      credit:"16",
      nationality:"Nigerian",
      status:"Graduate",
    },
    {
      name: "Daniel Regna",
      gender: "Female",
      course:"Agronomy",
      egrade:"130.0",
      credit:"16",
      nationality:"Nigerian",
      status:"Graduate",
    },
    {
      name: "Daniel Regna",
      gender: "Female",
      course:"Agronomy",
      egrade:"130.0",
      credit:"16",
      nationality:"Nigerian",
      status:"Graduate",
    },
    {
      name: "Daniel Regna",
      gender: "Female",
      course:"Agronomy",
      egrade:"130.0",
      credit:"16",
      nationality:"Nigerian",
      status:"Graduate",
    },
    {
      name: "Daniel Regna",
      gender: "Female",
      course:"Agronomy",
      egrade:"130.0",
      credit:"16",
      nationality:"Nigerian",
      status:"Graduate",
    },
    {
      name: "Daniel Regna",
      gender: "Female",
      course:"Agronomy",
      egrade:"130.0",
      credit:"16",
      nationality:"Nigerian",
      status:"Graduate",
    },
    {
      name: "Daniel Regna",
      gender: "Female",
      course:"Agronomy",
      egrade:"130.0",
      credit:"16",
      nationality:"Nigerian",
      status:"Graduate",
    },
    {
      name: "Daniel Regna",
      gender: "Female",
      course:"Agronomy",
      egrade:"130.0",
      credit:"16",
      nationality:"Nigerian",
      status:"Graduate",
    },
    {
      name: "Daniel Regna",
      gender: "Female",
      course:"Agronomy",
      egrade:"130.0",
      credit:"16",
      nationality:"Nigerian",
      status:"Graduate",
    },
    {
      name: "Daniel Regna",
      gender: "Female",
      course:"Agronomy",
      egrade:"130.0",
      credit:"16",
      nationality:"Nigerian",
      status:"Graduate",
    },
  ],
};
